import { render, staticRenderFns } from "./SourceJson.vue?vue&type=template&id=068f17ed"
import script from "./SourceJson.vue?vue&type=script&lang=js"
export * from "./SourceJson.vue?vue&type=script&lang=js"
import style0 from "./SourceJson.vue?vue&type=style&index=0&id=068f17ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports